var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 28,
    viewBox: "0 0 34 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3335 0.666626H3.66683C1.8335 0.666626 0.350163 2.16663 0.350163 3.99996L0.333496 24C0.333496 25.8333 1.8335 27.3333 3.66683 27.3333H30.3335C32.1668 27.3333 33.6668 25.8333 33.6668 24V3.99996C33.6668 2.16663 32.1668 0.666626 30.3335 0.666626ZM29.6668 7.74996L17.8835 15.1166C17.3502 15.45 16.6502 15.45 16.1168 15.1166L4.3335 7.74996C4.16638 7.65614 4.02003 7.52939 3.90331 7.37738C3.78659 7.22537 3.70193 7.05126 3.65446 6.86558C3.60698 6.6799 3.59767 6.48652 3.62709 6.29714C3.65651 6.10776 3.72406 5.92632 3.82563 5.76379C3.92721 5.60127 4.0607 5.46105 4.21804 5.35162C4.37538 5.24218 4.55328 5.16581 4.74099 5.12712C4.9287 5.08844 5.1223 5.08824 5.31009 5.12654C5.49787 5.16484 5.67594 5.24085 5.8335 5.34996L17.0002 12.3333L28.1668 5.34996C28.3244 5.24085 28.5025 5.16484 28.6902 5.12654C28.878 5.08824 29.0716 5.08844 29.2593 5.12712C29.447 5.16581 29.625 5.24218 29.7823 5.35162C29.9396 5.46105 30.0731 5.60127 30.1747 5.76379C30.2763 5.92632 30.3438 6.10776 30.3732 6.29714C30.4027 6.48652 30.3934 6.6799 30.3459 6.86558C30.2984 7.05126 30.2137 7.22537 30.097 7.37738C29.9803 7.52939 29.834 7.65614 29.6668 7.74996Z",
    fill: "#F96B09"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.c6383640b069cf9ba018cd4e15330b69.svg";
export { ForwardRef as ReactComponent };